class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('[data-header-wrapper]');
    this.closeTimeout = null;
    this.parentLi = this.closest('li');
    this.menuContent = this.mainDetailsToggle.querySelector('[data-mega-menu-content]');
    // 메뉴 글자뿐 아니라 summary 여백·caret·드롭다운까지 하나의 hover 영역으로 처리
    this.hoverTrigger = this.parentLi || this.mainDetailsToggle.querySelector('summary');
    if (this.hoverTrigger) {
      this.hoverTrigger.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.hoverTrigger.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
    if (this.menuContent) {
      this.menuContent.addEventListener('mouseenter', this.onMenuContentEnter.bind(this));
      this.menuContent.addEventListener('mouseleave', this.onMenuContentLeave.bind(this));
    }
    const summary = this.mainDetailsToggle.querySelector('summary');
    const link = summary.querySelector('[data-menu-item-link]');
    if (link) {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        }
      });
      summary.addEventListener('click', (e) => {
        if (e.target.closest('[data-menu-item-link]')) {
          e.preventDefault();
          return;
        }
      });
    }
  }
  // 다른 열린 메뉴들 즉시 닫기
  closeOtherMenus() {
    const allMenus = document.querySelectorAll('header-menu');
    allMenus.forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.hasAttribute('open')) {
        if (menu.closeTimeout) clearTimeout(menu.closeTimeout);
        menu.close();
      }
    });
  }
  cancelClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }
  onMouseEnter() {
    this.cancelClose();
    // 다른 메뉴 즉시 닫기
    this.closeOtherMenus();
    // 즉시 메뉴 열기
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    }
  }
  onMouseLeave() {
    // 메뉴와 드롭다운 경계에서 브라우저가 hover 상태를 갱신할 시간을 확보
    this.closeTimeout = setTimeout(() => {
      this.attemptClose();
    }, 250);
  }
  onMenuContentEnter() {
    this.cancelClose();
  }
  onMenuContentLeave() {
    // 메뉴로 돌아갈 시간을 주기 위해 짧은 지연
    this.closeTimeout = setTimeout(() => {
      this.attemptClose();
    }, 250);
  }
  attemptClose() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      // 아직 hover 중이면 닫지 않음
      if (this.hoverTrigger && this.hoverTrigger.matches(':hover')) return;
      if (this.menuContent && this.menuContent.matches(':hover')) return;
      this.close();
    }
  }
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
customElements.define('header-menu', HeaderMenu);
